module.exports = __webpack_public_path__ + "img/LC_icon_user_fill_3.f468db06.svg";